import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import axios from '../axiosConfig';
import { FaChartBar, FaBook, FaSignOutAlt, FaBars, FaTrash } from 'react-icons/fa';

const SidebarContainer = styled.div`
    width: ${({ isCollapsed }) => (isCollapsed ? '80px' : '250px')};
    height: 100vh;
    background-color: #147f59;
    display: flex;
    flex-direction: column;
    align-items: ${({ isCollapsed }) => (isCollapsed ? 'center' : 'flex-start')};
    padding: 20px 0;
    position: fixed;
    top: 0;
    left: 0;
    transition: width 0.3s ease;
`;

const ToggleButton = styled.button`
    background-color: transparent;
    border: none;
    color: white;
    font-size: 24px;
    margin-bottom: 20px;
    cursor: pointer;
`;

const SidebarItem = styled(Link)`
    width: 100%;
    padding: 15px 20px;
    color: white;
    text-decoration: none;
    display: flex;
    align-items: center;
    border-style: outset;

    &:hover {
        background-color: #7eb19d;
    }

    span {
        margin-left: ${({ isCollapsed }) => (isCollapsed ? '0' : '10px')};
        display: ${({ isCollapsed }) => (isCollapsed ? 'none' : 'inline')};
        transition: margin 0.3s ease;
    }
`;

const ResetButton = styled.button`
    width: 100%;
    padding: 15px 20px;
    color: white;
    background-color: #d9534f;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    border-style: outset;

    &:hover {
        background-color: #c9302c;
    }

    span {
        margin-left: ${({ isCollapsed }) => (isCollapsed ? '0' : '10px')};
        display: ${({ isCollapsed }) => (isCollapsed ? 'none' : 'inline')};
        transition: margin 0.3s ease;
    }
`;

const Modal = styled.div`
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: white;
    padding: 20px;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
    z-index: 1000;
`;

const Overlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 999;
`;

const Loader = styled.div`
    margin-top: 20px;
    border: 4px solid #f3f3f3;
    border-radius: 50%;
    border-top: 4px solid #3498db;
    width: 20px;
    height: 20px;
    animation: spin 1s linear infinite;

    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }
`;

const Sidebar = ({ isCollapsed, toggleSidebar }) => {
    const [isModalOpen, setModalOpen] = useState(false);
    const [isLoading, setLoading] = useState(false);

    const handleResetData = async () => {
        setLoading(true);
        try {
            const response = await axios.delete('/transaction/all');
            if (response.status === 200) {
                alert('Данные успешно сброшены');
            } else {
                alert('Ошибка при сбросе данных');
            }
        } catch (error) {
            console.error('Ошибка:', error);
            alert('Ошибка при сбросе данных');
        } finally {
            setLoading(false);
            setModalOpen(false);
        }
    };

    return (
        <>
            <SidebarContainer isCollapsed={isCollapsed}>
                <ToggleButton onClick={toggleSidebar}>
                    <FaBars />
                </ToggleButton>
                <SidebarItem to="/" isCollapsed={isCollapsed}>
                    <FaChartBar />
                    <span>Ликвидность</span>
                </SidebarItem>
                <SidebarItem to="/commissions" isCollapsed={isCollapsed}>
                    <FaBook />
                    <span>Коммиссии</span>
                </SidebarItem>
                <SidebarItem to="/limits" isCollapsed={isCollapsed}>
                    <FaBook />
                    <span>Лимиты</span>
                </SidebarItem>
                <SidebarItem to="/conversion" isCollapsed={isCollapsed}>
                    <FaBook />
                    <span>Конвертации</span>
                </SidebarItem>
                <SidebarItem to="/transaction" isCollapsed={isCollapsed}>
                    <FaBook />
                    <span>Транзакции</span>
                </SidebarItem>
                <ResetButton onClick={() => setModalOpen(true)} isCollapsed={isCollapsed}>
                    <FaTrash />
                    <span>Сбросить данные</span>
                </ResetButton>
                <SidebarItem to="/logout" isCollapsed={isCollapsed}>
                    <FaSignOutAlt />
                    <span>Выход</span>
                </SidebarItem>
            </SidebarContainer>

            {isModalOpen && (
                <>
                    <Overlay onClick={() => setModalOpen(false)} />
                    <Modal>
                        <p>Вы уверены, что хотите сбросить все данные?</p>
                        <button onClick={handleResetData} disabled={isLoading}>Да</button>
                        <button onClick={() => setModalOpen(false)} disabled={isLoading}>Нет</button>
                        {isLoading && <Loader />}
                    </Modal>
                </>
            )}
        </>
    );
};

export default Sidebar;
